import { useEffect } from 'react'
import { fbt } from 'fbtee'
import { useAuth } from './useAuth'
import { ensureAnonAuth } from '../lib/firebase'
import { recordSignupSource, type SignupSource } from '../lib/signupSource'
import { toastError } from '../lib/toast'

// Shared mount-time bootstrap for the guest-landing routes (/add, /join, /t):
// remember how the visitor arrived so a later sign_up is attributed to the
// growth loop, then ensure an (anonymous) session so the page's reads and its
// guest write can proceed. AuthProvider pre-triggers ensureAnonAuth for /join
// and /t cold loads and ensureAnonAuth dedupes, so this only does real work on
// in-app navigation into these routes.
export function useGuestLandingSession(source: SignupSource): void {
  const { user, loading: authLoading } = useAuth()

  // First write wins, so re-running on a source change is safe.
  useEffect(() => {
    recordSignupSource(source)
  }, [source])

  useEffect(() => {
    if (authLoading || user) return
    ensureAnonAuth().catch(() => {
      toastError(
        fbt('Something went wrong', 'Generic error toast title'),
        fbt(
          'Could not start a session. Please try again.',
          'Error when anonymous sign-in fails on a guest landing page',
        ),
      )
    })
  }, [authLoading, user])
}
